module.exports = __webpack_public_path__ + "static/img/jb_pic1.7c833cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jb_pic1.jpg
// module id = JjFp
// module chunks = 5